<template>
    <div>
        <breadcrumb :routerList="[{to:'/credit',title:'经理销售维度'},{title:'客户详情'}]"/>
        <div class="h-content">
            <!--		<div class="h-pieceIn2 icon">-->
            <!--		    <div class="h-pieceCon2" style="width:100%;padding:20px 10px;border:1px solid #d7e0f1;background-color: white;margin-bottom: 30px;">-->
            <!--		        <div class="stepBox">-->
            <!--		            <div class="leftstep">销售经理</div>-->
            <!--		            <div class="rightstep">-->
            <!--		                <div class="readiu">-->
            <!--		                    <img src="../../../assets/images/checksuccess.png" alt="" style="" />-->
            <!--		                </div>-->
            <!--		            </div>-->
            <!--		            <div class="leftstep">区域经理</div>-->
            <!--		            <div class="fukaun">-->
            <!--		                <div class="color">-->
            <!--		                    &lt;!&ndash; <img src="../../../assets/images/checksuccess.png" alt="" class="bac-color">                             &ndash;&gt;-->
            <!--		                </div>-->
            <!--		            </div>-->
            <!--		            <div class="fuwu">客户主管</div>-->
            <!--		            <div class="fukaun">-->
            <!--		                <div class="color">-->
            <!--		                    &lt;!&ndash; <img src="../../../assets/images/checksuccess.png" alt="" > &ndash;&gt;-->
            <!--		                </div>-->
            <!--		            </div>-->
            <!--		           -->
            <!--		            <div class="fuwu">财务经理</div>-->
            <!--		        </div>-->
            <!--		    </div>-->
            <!--		</div>-->
            <div class="h-row h-mrt0 D-dai" style="margin:0 -0.12rem ;">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <el-form :model="zy" label-position="right" ref="zy" :rules="rules" :inline="true"
                                class="demo-ruleForm h-formbLine h-formbLine1">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>信贷信息</h1>
                                    </div>

                                    <div class="h-pieceCon2">
                                        <div class="h-formLine weekplandetail">
                                            <el-form-item label="客户名称" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.username" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="信贷种类" class="h-elformWrap-2" prop="creCategory">
                                                <brselectlazy category="cre_category" :v="zy.creCategory"
                                                                v-model="zy.creCategory" :clearable="true" disabled
                                                />
                                            </el-form-item>
                                            <el-form-item label="专属产品大类" class="h-elformWrap-2" prop="productId"
                                                            v-if="zy.creCategory == '0'">
                                                <brselectlazy category="product_level1" :v="zy.productId"
                                                                v-model="zy.productId" :clearable="true" disabled
                                                />
                                            </el-form-item>
                                            <el-form-item label="申请金额" class="h-elformWrap-2">
                                                <el-input :readonly="!isCaiwu" placeholder="请输入" v-model="zy.maxquota"
                                                            style="width: 2.7rem;" @change="exchange"></el-input>
                                                <span>{{zy.currency}}</span>
                                            </el-form-item>
                                            <!--                                            <el-form-item label="承诺回款时间" class="h-elformWrap-2">-->
                                            <!--                                                <el-input placeholder="请输入" v-model="zy.receDate" readonly></el-input>-->
                                            <!--                                            </el-form-item>-->
                                            <!--                                            <el-form-item label="是否有签字" class="h-elformWrap-2">-->
                                            <!--                                                <el-select v-model="zy.isSign" placeholder="请选择" disabled>-->
                                            <!--                                                    <el-option label="是" value="1"></el-option>-->
                                            <!--                                                    <el-option label="否" value="2"></el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->
                                            <!--                                            <el-form-item label="是否有逾期" class="h-elformWrap-2">-->
                                            <!--                                                <el-select v-model="zy.isOverdue" placeholder="请选择" disabled>-->
                                            <!--                                                    <el-option label="是" value="1"></el-option>-->
                                            <!--                                                    <el-option label="否" value="2"></el-option>-->
                                            <!--                                                </el-select>-->
                                            <!--                                            </el-form-item>-->
                                            <!--                                            <el-form-item label="签字单位" class="h-elformWrap-2">-->
                                            <!--                                                <el-input placeholder="请输入" v-model="zy.signCompany"-->
                                            <!--                                                          readonly></el-input>-->
                                            <!--                                            </el-form-item>-->
                                            <el-form-item label="申报时间" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.cdate" readonly></el-input>
                                            </el-form-item>
                                            <el-form-item label="承诺回款时间" class="h-elformWrap-2"
                                                        v-if="this.countrytype == '1'">
                                                <el-input placeholder="请输入" v-model="zy.validitydate" :readonly="!isCaiwu"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item label="批复账期" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" v-model="zy.paymentdate" :readonly="!isCaiwu"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item  v-if="zy.currency != 'CNY'" label="RMB金额"  class="h-elformWrap-2">
                                                <el-input :readonly="!isCaiwu" placeholder="请输入" v-model="zy.rmbquota"
                                                          style="width: 2.7rem;"></el-input>
                                            </el-form-item>
                                            <el-form-item label="公司代码" class="h-elformWrap-2" prop="kkber">
                                                <brselectlazy category="kkber_value" :v="zy.kkber" v-model="zy.kkber"
                                                            :clearable="true" disabled
                                                />
                                            </el-form-item>

                                            <el-form-item label="销售经理" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" readonly
                                                        v-model="zy.qdmanger"></el-input>
                                            </el-form-item>
                                            <el-form-item label="省区经理" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" readonly
                                                        v-model="zy.qymanger"></el-input>
                                            </el-form-item>
                                            <el-form-item label="平台接口人" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" readonly
                                                        v-model="zy.ptjkr"></el-input>
                                            </el-form-item>
                                            <el-form-item label="小微主" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" readonly
                                                        v-model="zy.lianqunzhu"></el-input>
                                            </el-form-item>
                                            <el-form-item label="节点接口人" class="h-elformWrap-2">
                                              <el-input placeholder="请输入" readonly
                                                        v-model="zy.jdjkr"></el-input>
                                            </el-form-item>

                                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                                <el-input  readonly
                                                          v-model="zy.projectName"></el-input>
                                            </el-form-item>
                                            <el-form-item label="渠道" class="h-elformWrap-2">
                                                <el-input  readonly
                                                           v-model="zy.ywType"></el-input>
                                            </el-form-item>

                                            <el-form-item label="备注" class="h-elformWrap-2">
                                                <el-input placeholder="请输入" readonly
                                                        v-model="zy.signCompany"></el-input>
                                            </el-form-item>
                                            <!--                                            <el-form-item label="风险类别" class="h-elformWrap-2" prop="ctlpc">-->
                                            <!--                                                <brselectlazy category="ctlpc_value" :v="zy.ctlpc" v-model="zy.ctlpc"-->
                                            <!--                                                              :clearable="true" disabled-->
                                            <!--                                                              style="width:1.7rem"/>-->
                                            <!--                                            </el-form-item>-->
                                            <!--								   <el-form-item label="批复凭证" class="h-elformWrap-2" >-->
                                            <!--								   		<el-input placeholder="请输入" v-model="zy.pfpz"></el-input>-->
                                            <!--								   </el-form-item>-->
                                            <el-form-item label="批复凭证图片" class="h-elformWrap-2 extraItem"
                                                        style="width:100%!important;">
                                                <brupload
                                                        v-if="isShow"
                                                        :refid="refid"
                                                        style="display:none"
                                                        reftype="信贷管理-新增信贷"
                                                >
                                                </brupload>
                                                <div class="new-yulan">
                                                    <ul v-for="(item,index) in fileList" :key="index">
                                                        <li><a :href=" 'https://oms.haierbiomedical.com/' + item.saveurl" target="_blank" ><h3><i class="el-icon-document"></i>{{item.name}}<span>{{item.cdate}}</span></h3></a></li>
                                                    </ul>
                                                </div>
                                                <el-dialog :visible.sync="dialogVisible">
                                                    <img width="100%" :src="dialogImageUrl" alt="">
                                                </el-dialog>
                                            </el-form-item>
                                            <div>
                                                <div style="color: #ff0000;font-size: 16px;">
                                                <span v-if="this.zy.isNeixiao == '1'">提示：附件请上传签批完整的信贷申请（非中信保信贷）、框架合同补充协议或直单合同；以上必填项请市场节点人员审批。相关责任人对业务真实性负责，同意按照公司应收考核机制接受考核。
                                                </span>
                                                    <span v-if="this.zy.isNeixiao == '0'">提示：附件请上传给中信保审批单，以上必填项与中信保客户信息保持一致
                                                </span>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>审核信息</h1>
                                    </div>
                                    <div class="h-pieceCon2 ">
                                        <div class="h-formLine weekplandetail" style="position: relative;">
                                            <el-form :inline="true" :model="zy"
                                                    ref="formLabelAlign1" :rules="rules">
                                                <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                    prop="yjMsg">
                                                    <el-input
                                                            v-model="zy.yjMsg"
                                                            placeholder="请输入"></el-input>
                                                </el-form-item>
                                            </el-form>
                                            <el-button class="passfollow" @click="viewpress">
                                                <img src="../../../assets/images/followicon.png"
                                                    style="margin-bottom: -0.08rem;">
                                                审批跟踪
                                            </el-button>
                                            <viewhistory
                                                :visible.sync="showhistory"
                                                v-if="showhistory"
                                                :id="data.instid"
                                                />
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </el-form>
                    </div>
                    <div class="h-table h-mrt30    kehu">
                        <div class="h-pieceTitle2 hang" style="margin-bottom: 0.2rem;">
                            <h1>审核信息</h1>
                        </div>
                        <el-form
                                :inline="true"
                                :model="zy"
                                ref="formLabelAlign1"
                                :rules="rules" class="demo-ruleForm h-formbLine ">
                            <el-form-item
                                    label="审批意见"
                                    class="h-elformWrap-2"
                                    style="margin:0 0 40px -7px"
                                    prop="yjMsg">
                                <el-input
                                        v-model="zy.yjMsg"
                                        placeholder="请输入">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="是否跳过财务部长审批" v-if="isShowSkipLeader">
                                <el-select v-model="zy.isSkipCwbz"
                                            placeholder="请选择">
                                    <el-option label="是"
                                                value='1'></el-option>
                                    <el-option label="否"
                                                value="0"></el-option>
                                </el-select>
                            </el-form-item>
                          <!--  <el-form-item label="是否跳过CEO审批" v-if="isShowSkipLeader">
                                <el-select v-model="zy.isSkipCEO"
                                            placeholder="请选择">
                                    <el-option label="是"
                                                value='1'></el-option>
                                    <el-option label="否"
                                                value="0"></el-option>
                                </el-select>
                            </el-form-item>-->
                        </el-form>
                        <viewhistory
                                :visible.sync="showhistory"
                                v-if="showhistory"
                                :id="data.instid"
                        />
                    </div>
                    <div style="text-align: center; padding: 74px">
                        <el-button class="h-btn h-bBtn " :class="this.data.taskstatus == '1'? null:'h-bgwhite'"
                                    @click="goBack">返回
                        </el-button>
                        <el-button class="h-btn h-bBtn h-bgred"
                                    @click="approveFailed" v-show="this.data.taskstatus != '1'">驳回
                        </el-button>
                        <el-button class="h-btn h-bBtn h-bggreen" @click="approveSuccess"
                                    v-show="this.data.taskstatus != '1'">通过
                        </el-button>
                        <el-button class="h-btn h-bBtn" @click="viewpress">
                            审批跟踪
                        </el-button>
                        <!-- <img src="../../../assets/images/followicon.png"
                                style="margin-bottom: -0.08rem;"> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import creditApproveService from "../../../api/loud/credit/creditApproveService";
    import agentCopyService from "../../../api/loud/agent/agentCopyService";
    import uploaddown from '../../../utils/updownfile'
    import customerDetailsService from "../../../api/loud/credit/customerDetailsService";

    export default {
        data() {
            return {
                fileList:[],
                isCaiwu: false,
                isShowSkipLeader: false,
                countrytype: '',
                rules: {
                    yjMsg:
                        [
                            {required: true, message: '请填写必填项', trigger: 'blur'},
                        ],
                },
                showhistory: false,
                isShow: false,
                refid: null,
                tabIndex: 1,
                zy: {
                    username: '',
                    id: null,
                    maxquota: null,
                    receDate: null,
                    isSign: null,
                    isOverdue: null,
                    signCompany: null,
                    cdate: null,
                    validitydate: null,
                    taskid: null,
                    aaa: null,
                    kkber: null,
                    ctlpc: null,
                    creCategory: null,
                    productId: null,
                    yjMsg: '',
                    isSkipCwbz: '0',
                    isSkipCEO: '0',
                    isNeixiao: null,
                },
                //表单
                q: {
                    cdateBegin: null,
                    cdateEnd: null,
                    pageSize: 10,

                },
                //表格
                multipleSelection: [],
                options1: [
                    {value: 1, label: '有签字'},
                    {value: 2, label: '逾期'},
                ],
                data: {},

            };
        },
        created() {
            this.isRead();
            this.data = this.$route.query;
            console.log(this.data, 'data');
            this.checkCredit();
            this.getAgent();
            agentCopyService.getNowTask(this.$route.query.taskid).then(res => {
                this.isShowSkipLeader = res;
            });
        },
        methods: {
            //测试
            test(){
                var yuming =window.location.host
                var  refid = this.refid
                // console.log(this.refid)
                uploaddown.listdownfile({refid:this.refid, reftype: '信贷管理-新增信贷'}).then(res => {
                    console.log(res, '待审核的信贷信息');
                    this.fileList = res.obj
                })
            },
            isRead() {
                for (var i = 0; i < this.$store.getters.roles.length; i++) {
                    if (this.$store.getters.roles[i].id == 'swyl_xindai') {
                        this.isCaiwu = true;
                    }
                }
            },
            getAgent() {
                creditApproveService.getAgent(this.data.ywid).then(response => {
                    console.log(response, '当前被审核的客户资料');
                    this.countrytype = response.countrytype;
                })
            },
            viewpress() {
                this.showhistory = true;
            },
            goBack() {
                var defaultpage = this.$store.getters.user.defaultpage
                this.$router.push({path: defaultpage});
            },
            checkCredit() {
                creditApproveService.query(this.data.instid).then(response => {
                    console.log(response, '待审核的信贷信息');
                    this.refid = response.obj.id;
                    this.test()
                    this.isShow = true;
                    this.zy = response.obj;
                    if (this.zy.isSign != undefined && this.zy.isOverdue != undefined) {
                        this.zy.isSign = this.zy.isSign.toString();
                        this.zy.isOverdue = this.zy.isOverdue.toString();
                    }
                    this.zy.taskid = this.data.taskid;
                    console.log(this.zy, 'asdfasfasfasfasfsdfasfasfsafas')
                })
            },
            //点击驳回按钮功能
            approveFailed() {
                this.zy.aaa = 2;
                creditApproveService.approveCreate(this.zy);
                this.$message({
                    type: "success",
                    message: "审批成功"
                });
                this.$router.push({path: "/"});
            },
            //点击通过按钮功能
            approveSuccess() {
                this.zy.aaa = 1;
                console.log(this.zy, '点击通过时的信息')
                creditApproveService.approveCreate(this.zy).then(res => {
                    this.$message({
                        type: "success",
                        message: "审批成功"
                    });
                    this.$router.push({path: "/"});
                })

            },
          // 20220421 添加 申请金额 与RMB金额 换算
            exchange(){
              if(this.zy.maxquota && this.zy.currency){
                customerDetailsService.exchange(this.zy.maxquota,this.zy.currency).then(res => {
                  this.zy.rmbquota = res;
                })
              }
            },
            tabchange(i) {
                this.tabIndex = i;
            },

        },
        mounted() {

        }
    };
</script>
<style scoped="scoped" lang="scss">
.new-yulan{
    width: 100%;
    margin: 0 auto;
}
.new-yulan ul li{
    padding:5px 0
}
.new-yulan ul li h3{
    text-align: left;
    font-weight: 400;
    color: #0e75e9;
    font-size: 14px
}
.new-yulan ul li h3 i{
    padding: 0 5px;
    color: #606266
}
.new-yulan ul li h3 span{
    text-align: right;
    color: #606266;
    float: right;
    font-size: 13px
}
    .color {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        border: 3px solid #c7c8ca;
        position: relative;
        left: 74px;
        top: -12px;
        background-color: white;
    }

    img {
        width: 18px;
        padding: 3px 0;
        margin-left: 0.035rem;
        color: block;
    }

    .h1 {
        margin-left: 27px;
    }

    .passfollow {
        background-color: #2686e7;
        color: white;
    }

    .hang {
        padding-top: 20px;
        background-color: white;
        margin-left: 20px;
    }

    .kehu {
        background-color: white;

    }
</style>
<style>
    .D-dai .h-formbLine .el-form-item__content .el-input {
        width: 100%;
    }

    .D-dai .h-formbLine .el-form-item__content .el-select {
        width: 100%;
    }

    .D-dai .h-formbLine .el-form-item__label {
        width: 32%;
        text-align: right;
    }

    .D-dai .h-formbLine .el-form-item__content {
        width: 68%;
    }

    .D-dai .h-formbLine .h-elformWrap-2 {
        width: 33.333% !important;
        padding-right: 0.5rem
    }

    .D-dai .h-formbLine .extraItem .el-form-item__label {
        width: 9.7%;
        text-align: right;
    }
</style>
